export default "__VITE_ASSET__CEHR3L3T__"